// extracted by mini-css-extract-plugin
module.exports = {"container":"Mobile_container__2QFO6","logo":"Mobile_logo__1j5mH"};